import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import GreenLogo from "./GreenLogo";

const ProfileBackgroundPics = ({
  user,
  profile,
  setbio,
  setColor,
  color,
  setEditing,
}) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          {profile &&
          profile.backgroundimageone === "Innovate_Me_logo_green.png" ? (
            <div className="profile-logo-container">
              <GreenLogo />
            </div>
          ) : (
            <img
              className={"profile-background-image"}
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/innovators/${profile.backgroundimageone}`}
              alt="background"
            />
          )}
          <div className="profile-user-info">
            {user && user.user === profile.user ? (
              <div
                className="profile-user-info-button-green green"
                onMouseOver={() => setColor(true)}
                onMouseLeave={() => setColor(false)}
              >
                <Link to={`/${user.channelid}/edit`}>
                  <span
                    className={color ? "black" : "green"}
                    onClick={() => setEditing(true)}
                  >
                    Edit Profile
                  </span>
                </Link>
              </div>
            ) : (
              <div
                className="profile-user-info-button-green green"
                onClick={() => setbio(true)}
              >
                Biography
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProfileBackgroundPics;
